import { useState } from 'react'
import { usePwaInstall } from './usePwaInstall'
import { IosInstallHelp } from './IosInstallHelp'

/**
 * Bannière douce d'installation, fixée en bas de viewport, dismissible.
 * Montée uniquement dans la zone authentifiée (jamais sur la landing vitrine).
 */
export function InstallBanner() {
  const { canInstall, isStandalone, isIosSafari, dismissed, promptInstall, dismiss } = usePwaInstall()
  const [showIosHelp, setShowIosHelp] = useState(false)

  if (isStandalone || dismissed) return null
  if (!canInstall && !isIosSafari) return null

  const handleInstall = () => {
    if (canInstall) void promptInstall()
    else setShowIosHelp(true)
  }

  return (
    <>
      <div className="fixed inset-x-0 bottom-0 z-40 border-t border-sand-500/20 bg-ocean-900/95 backdrop-blur-md">
        <div className="max-w-3xl mx-auto px-4 py-3 flex items-center gap-3">
          <img src="/corsalia-logo.svg" alt="" className="w-8 h-8 shrink-0" />
          <p className="min-w-0 flex-1 text-sm text-ocean-100">
            Installe Corsalia pour la retrouver d'un geste, plein écran.
          </p>
          <button
            type="button"
            onClick={handleInstall}
            className="shrink-0 rounded-md bg-ocean-700 px-3 py-1.5 text-sm text-sand-100 border border-sand-500/30 hover:bg-ocean-500 transition-colors"
          >
            Installer l'app
          </button>
          <button
            type="button"
            onClick={dismiss}
            className="shrink-0 rounded-md px-2 py-1.5 text-sm text-ocean-300 hover:text-sand-200 transition-colors"
          >
            Plus tard
          </button>
        </div>
      </div>
      {showIosHelp && <IosInstallHelp onClose={() => setShowIosHelp(false)} />}
    </>
  )
}
